<template>
  <div>
    <SiruiSearch
      ref="formItem"
      :query="baseFormData"
      :columns="formColumn"
      :isQueryPanel="false"
      :rules="formRules"
      @changeMethod="changeMethod"
      :isDisabledForm="isDisabledForm"
    >
    </SiruiSearch>
    <!-- 预警提醒 -->
    <el-form
      :model="form"
      :rules="rules"
      ref="fromRef"
      label-width="120px"
      class="demo-ruleForm"
      size="small"
      style="padding-right: 10px"
      :disabled="isDisabledForm"
    >
      <el-row :gutter="20">
        <el-col :span="24">
          <el-form-item style="">
            <template slot="label">
              <el-tooltip placement="top" effect="dark">
                <span style="color: red">预警提醒</span>
              </el-tooltip>
            </template>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="6">
          <el-form-item label="最晚发货日" prop="latestShipmentDate"
            ><template slot="label">
              <el-tooltip placement="top" effect="dark">
                <span ::class="{ propClass: tipText1>propLength }">最晚发货日</span>
                <div slot="content" v-html="tipText1"></div>
              </el-tooltip>
            </template>
            <el-date-picker
              type="date"
              v-model="form.latestShipmentDate"
              format="yyyy-MM-dd"
              style="width: 100%"
              placeholder="请选择最晚发货日"
            ></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="最晚提货日" prop="latestPickUpFate">
            <inputNumber
              v-model="form.latestPickUpFate"
              :controls="false"
              class="inputWidth"
              append="天"
              :min="-99999999999999999"
              :max="99999999999999999"
            ></inputNumber>
            <template slot="label">
              <el-tooltip placement="top" effect="dark">
                <span ::class="{ propClass: tipText2>propLength }">最晚提货日</span>
                <div slot="content" v-html="tipText2"></div>
              </el-tooltip>
            </template>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="最晚应付结算日" prop="latestPayableSettlementFate">
            <inputNumber
              v-model="form.latestPayableSettlementFate"
              :controls="false"
              class="inputWidth"
              append="天"
              :min="-99999999999999999"
              :max="99999999999999999"
            ></inputNumber>
            <template slot="label">
              <el-tooltip placement="top" effect="dark">
                <span ::class="{ propClass: tipText1>propLength }">最晚应付结算日</span>
                <div slot="content" v-html="tipText3"></div>
              </el-tooltip>
            </template>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="回票日期" prop="replyInvoiceFate" :span="6">
            <inputNumber
              v-model="form.replyInvoiceFate"
              :controls="false"
              class="inputWidth"
              append="天"
              :min="-99999999999999999"
              :max="99999999999999999"
            ></inputNumber>
            <template slot="label">
              <el-tooltip placement="top" effect="dark">
                <span ::class="{ propClass: tipText1>propLength }">回票日期</span>
                <div slot="content" v-html="tipText4"></div>
              </el-tooltip>
            </template>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
  import { baseForm, baseFormRule } from './index.js';
  import BASE_API from '@/api/dataBase';
  import { formatDate } from '@/utils';
  import BASEAPI from '@/api/dataBase.js';
  import btnMix from '../../../../bilateralContract/bilateralContractDetail/btnMix';
  export default {
    name: 'ContractForm',
    mixins: [btnMix],
    props: {
      // 不定价
      isDisabledPricingRule: {
        type: Boolean,
        default: false,
      },
      // 合同总金额
      contractTotalAmount: {
        type: Number,
        default: 0,
      },
      // 采购数量
      purchaseQuantity: {
        type: Number,
        default: 0,
      },
      // 远程数据
      fetchFormData: {
        type: Object,
        default: () => {},
      },
      contractStatus: {
        type: String,
        default: () => '',
      },
      isDisabledForm: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        baseFormData: {
          // contractCreateDate: '',
          version: null,
          projectInitiationNo: '',
          projectName: '',
          supplierNo: '',
          contractNo: '',
          contractName: '',
          contractType: '',
          contractTotalAmount: '',
          purchaseQuantity: '',
          overShippedPercentage: '',
          shortShippedPercentage: '',
          signDate: '',
          contractValidStart: '',
          contractValidEnd: '',
          companyCode: '',
          departmentCode: '',
          contractSalesmanNo: '',
          externalContractNo: '',
          contractCreateDate: '',
          replyInvoiceDate: '',
          companyCurrency: '',
          liquidatedDamagesType: '',
          liquidatedDamagesName: '',
          liquidatedFixedValue: '',
          liquidatedInterestRate: '',
          contractOperaterName: '',
          lastestPayMoneyDay: '',
          lastestReceiveProductDay: '',
          businessType: '',
          businessTypeName: '',
          isPrepay: '',
          creditAmount: '',
          receiptMethod: '',
          isFixedPrice: '0',
          isRestrict: '',
          isLongRange: '0',
          mark: '',

          platformCompanyFileNo: '',
          platformCompanyName: '',
        },
        companyList: [],
        departmentList: [],
        disabledFieldList: [],
        isCreate: false,
        currencyList: [],
        platformCompanyFileList: [],
        form: {},
        propLength: 13,
        tipText1: '业务员选择最晚日期后，到日期<br>后系统在首页进行提醒-入库', //最晚发货日
        tipText2:
          '业务员填写最晚提货天数后，进行<br>入库操作工作后，若经过填写的天数<br>后，系统在首页进行提醒-库存', //最晚提货日
        tipText3:
          '业务员填写最晚结算日天数后，进行入库<br>操作动作后，经过填写天数后，未进行结算<br>操作，系统在首页进行提醒-应付结算单', //最晚应付结算日
        tipText4: '业务员填写回票日期天数后，结<br>算单生效后，系统在首页进行<br>提醒-进项发票', //回票日期
      };
    },
    computed: {
      formColumn() {
        return baseForm(this);
      },
      formRules() {
        return baseFormRule(this);
      },
      rules() {
        return {};
      },
    },
    mounted() {
      this.isCreate = this.$route.query.status == 'create';
      this._initFormData();
      this._initDisabledList();
      this._getCurrency();
      this._getCompanyApi();
    },

    methods: {
      // 数字输入框
      updateInput(row, val, filed) {
        console.log(row, val, filed);
      },
      // 初始化数据
      _initFormData() {
        if (this.isCreate) {
          console.log('初始化表单数据----');
          this.baseFormData = {
            ...this.baseFormData,
            companyCode: this.userInfo.companyCode,
            companyName: this.userInfo.companyName,
            departmentCode: this.userInfo.departmentCode,
            departmentName: this.userInfo.departmentName,
            contractOperaterNo: this.userInfo.userCode,
            isNotEndDate: '1',
            contractOperaterName: this.userInfo.personName,
            contractCreateDate: formatDate(new Date()),
            companyCurrency: 'CNY',
            companyCurrencyName: '中国人民币（国际）',
            contractCurrency: 'CNY',
            contractCurrencyName: '中国人民币（国际）',
            incomeMethod: 'FIXED',
          };
        }
      },
      // 获取币种
      async _getCurrency() {
        const { data } = await this.$axios.get(BASEAPI.LIST_CURRENCY);
        if (data.code == 0) {
          this.currencyList = data.data.map((item) => {
            return {
              label: item.currencyName,
              value: item.currencyCode,
            };
          });
        }
      },
      // 初始化禁用列表
      _initDisabledList() {
        if (this.isCreate) {
          this.disabledFieldList = [
            'liquidatedDamagesType',
            'liquidatedFixedValue',
            'liquidatedInterestRate',
          ];
        }
      },
      // 切割平台公司
      splitPlatformtCompanyList(platformtCompany, platformtCompanyName) {
        if (platformtCompany && platformtCompanyName) {
          const platformtCompanyList = platformtCompany.split(',');
          const platformtCompanyNameList = platformtCompanyName.split(',');
          this.platformCompanyFileList = platformtCompanyList.map((item, index) => {
            return {
              label: platformtCompanyNameList[index],
              value: item,
            };
          });
        } else {
          this.platformCompanyFileList = [];
        }
      },
      changeMethod({ prop, val }) {
        console.log(prop, val, '切换选择');
        // 项目编号
        const rowData = (val && Array.isArray(val) && val[0]) || {};
        if (prop == 'projectInitiationNo') {
          this.baseFormData.projectInitiationNo = rowData?.projectInitiationNo;
          this.baseFormData.projectName = rowData?.projectName;
          // recyclingCompanyFileNo: '',
          // recyclingCompanyName: '',
          // platformCompanyCode: '',
          // platformCompanyFileNo: '',
          // platformCompanyName: '',
          // };
          this.baseFormData.platformCompanyFileNo = '';
          this.baseFormData.platformCompanyName = '';
          this.platformCompanyFileList = [];

          if (rowData) {
            // const recyclingtCompany = rowData?.recyclingtCompany;
            // const recyclingtCompanyName = rowData?.recyclingtCompanyName;
            const platformtCompany = rowData?.platformtCompany;
            const platformtCompanyName = rowData?.platformtCompanyName;
            // this.splitRecyclingCompanyFile(recyclingtCompany, recyclingtCompanyName);
            this.splitPlatformtCompanyList(platformtCompany, platformtCompanyName);
          }
          console.log('修改项目');
        } else if (prop == 'supplierNo') {
          // 修改供应商是否禁用开启协议
          const {
            partnerCode,
            partnerZhName,
            // departmentName,
            // departmentCode,
            isRelatedParty,
            ifPersonalPartner,
            partnerType,
            // companyCode,
            identityNo,
          } = rowData;
          console.log(
            partnerCode,
            partnerZhName,
            isRelatedParty,
            partnerType,
            '供应商',
            this.baseFormData.companyCode
          );
          this.baseFormData = {
            ...this.baseFormData,
            isGenerateSales: false,
            supplierNo: partnerCode,
            supplierName: partnerZhName,
            // generateSalesCompanyName: partnerZhName,
            // generateSalesCompanyNo: companyCode,
            identityNo,
            isRelatedParty,
            partnerType,
            ifPersonalPartner,
          };
          this.baseFormData.contractTotalAmount = '';
        } else if (prop == 'companyCode') {
          // 选择公司
          const currentItem = this.companyList.find((item) => item.personCompanyCode == val);
          this.baseFormData = {
            ...this.baseFormData,
            departmentCode: '',
            departmentName: '',
            supplierNo: '',
            supplierName: '',
            companyCode: val,
            companyName: currentItem?.personCompanyName,
            isGenerateSales: false,
          };
          if (val) {
            this._getDepartmentByCompanyCodeApi(val);
          }
          this.baseFormData.contractTotalAmount = '';
        } else if (prop === 'departmentCode') {
          // 选择部门的时候
          const currentItem = this.departmentList.find((item) => item.value == val);
          this.baseFormData = {
            ...this.baseFormData,
            departmentCode: val,
            departmentName: currentItem?.label,
          };
        } else if (prop == 'contractValidStart') {
          // 合同生效日期
        } else if (prop == 'contractValidEnd') {
          // 合同到期日期
        } else if (prop == 'contractSalesmanNo') {
          this.baseFormData = {
            ...this.baseFormData,
            contractSalesmanNo: rowData?.personNo,
            contractSalesmanName: rowData?.personName,
            // 手动添加
            personChargeName: rowData?.personName,
            personChargeCode: rowData?.personNo,
          };
        } else if (prop == 'contractOperaterName') {
          this.baseFormData = {
            ...this.baseFormData,
            contractOperaterName: rowData?.personName,
          };
        } else if (prop == 'companyCurrency') {
          // 币种
          const currencyName = this.currencyList.find((item) => item.value == val)?.label;
          this.baseFormData = {
            ...this.baseFormData,
            companyCurrency: val,
            companyCurrencyName: currencyName,
            contractCurrency: val,
            contractCurrencyName: currencyName,
          };
        } else if (prop == 'isPrepay') {
          if (!val) {
            this.baseFormData = {
              ...this.baseFormData,
              creditAmount: '',
            };
          }
        } else if (prop == 'receiptMethod') {
          const item = this.dictListMap?.receipt_method.find((item) => item.value == val);
          this.baseFormData.receiptMethod = val;
          this.baseFormData.receiptMethodName = item?.label;
        } else if (prop == 'isDefault') {
          if (val == '1') {
            //wumaoFix
            this.baseFormData = {
              ...this.baseFormData,
              liquidatedDamagesType: 'RATE',
              liquidatedDamagesName: '按利率',
            };
            console.log('==========');
            this.disabledFieldList = this.disabledFieldList.filter((item) => {
              return item != 'liquidatedDamagesType' && item != 'liquidatedInterestRate';
            });
          } else {
            this.baseFormData = {
              ...this.baseFormData,
              liquidatedDamagesType: '',
              liquidatedDamagesName: '',
              liquidatedFixedValue: '',
              liquidatedInterestRate: '',
            };
            this.disabledFieldList = [
              'liquidatedDamagesType',
              'liquidatedFixedValue',
              'liquidatedInterestRate',
            ];
          }
        } else if (prop == 'liquidatedDamagesType') {
          console.log('合同违约金类型', val);
          if (val == 'RATE') {
            this.disabledFieldList = ['liquidatedFixedValue'];
            this.baseFormData.liquidatedFixedValue = '';
            this.baseFormData.liquidatedDamagesName = '按利率';
          } else {
            this.disabledFieldList = ['liquidatedInterestRate'];
            this.baseFormData.liquidatedInterestRate = '';
            this.baseFormData.liquidatedDamagesName = '按固定值';
          }
        } else if (prop == 'companyCurrency') {
          this.baseFormData.companyCurrency = val;
          this.baseFormData.companyCurrencyName = this.currencyList.find(
            (item) => item.value == val
          )?.label;
        } else if (prop == 'platformCompanyFileNo') {
          // 回收编码
          // this.baseFormData.platformCompanyFileNo = val;
          const item = this.platformCompanyFileList.find((item) => item.value == val);
          // this.baseFormData.platformCompanyName = item?.label;

          this.baseFormData = {
            ...this.baseFormData,
            platformCompanyFileNo: val,
            platformCompanyName: item?.label,
          };
        }
        this.$emit('change', this.baseFormData);
      },
      async getValidateFormData() {
        let formData = await this.$refs.formItem.getValidateFormData();
        const currentStatus = this.$route.query.status;
        console.log(this.form, 'form');
        // TODO 特殊处理 还没找到原因
        if (formData.supplierNo && Array.isArray(formData.supplierNo)) {
          const {
            partnerCode,
            partnerZhName,
            isRelatedParty,
            ifPersonalPartner,
            partnerType,
            identityNo,
          } = formData.supplierNo[0];
          formData = {
            ...formData,
            isGenerateSales: false,
            supplierNo: partnerCode,
            supplierName: partnerZhName,
            identityNo,
            isRelatedParty,
            partnerType,
            ifPersonalPartner,
          };
        }
        return {
          ...formData,
          ...this.form,
          latestShipmentDate: this.form.latestShipmentDate
            ? formatDate(this.form.latestShipmentDate, true)
            : '',
          // 几个额外字段
          // departmentCode: this.userInfo.departmentCode,
          // departmentName: this.userInfo.departmentName,
          // companyCode: this.userInfo.companyCode,
          // companyName: this.userInfo.companyName,
          adminFlag: this.userInfo.adminFlag,
          // 特殊处理id
          id:
            ['create', 'renew'].includes(currentStatus) && this.contractStatus != '01'
              ? ''
              : formData?.id,
        };
      },
      // 获取公司
      async _getCompanyApi() {
        this.loading.startLoading();
        const { data } = await this.$axios.post(BASE_API.GET_PERSON_API, {
          id: this.userInfo.userCode,
          userCode: this.userInfo.userCode,
          personName: this.userInfo.userName,
        });
        this.loading.endLoading();
        if (data.code == 0) {
          this.companyList = data.data?.personCompanyInfo;
          // 默认初始化全部表单数据
          if (this.baseFormData.companyCode) {
            // 获取部门下拉
            this._getDepartmentByCompanyCodeApi(this.baseFormData.companyCode);
          }
        } else {
          console.error('获取公司失败');
        }
      },
      // 根据公司获取部门
      async _getDepartmentByCompanyCodeApi(companyCode) {
        if (companyCode) {
          const { data } = await this.$axios.post(BASE_API.GET_PERSON_API, {
            id: this.userInfo.userCode,
            userCode: this.userInfo.userCode,
            personName: this.userInfo.userName,
            personCompanyCode: companyCode,
          });
          if (data.code == 0) {
            this.departmentList = data.data?.personDepartmentInfo.map((item) => {
              return {
                label: item.personDepartmentName,
                value: item.personDepartmentCode,
              };
            });
          } else {
            console.error('获取部门失败');
          }
        }
      },
      async getProjectByProjectNo(projectInitiationNo) {
        const { data } = await this.$axios.post('/sales/goodsTradeProject/purchaseContractPage', {
          projectInitiationNo,
        });
        if (data.code == 0) {
          const rowData = data.data[0];
          const platformtCompany = rowData.platformtCompany;
          const platformtCompanyName = rowData.platformtCompanyName;
          // const recyclingtCompany = rowData.recyclingtCompany;
          // const recyclingtCompanyName = rowData.recyclingtCompanyName;
          // this.splitRecyclingCompanyFile(recyclingtCompany, recyclingtCompanyName);
          this.splitPlatformtCompanyList(platformtCompany, platformtCompanyName);
        } else {
          console.error('根据项目号获取项目信息失败');
        }
      },
    },
    watch: {
      // 合同总金额
      contractTotalAmount: {
        handler(val) {
          this.baseFormData = {
            ...this.baseFormData,
            contractTotalAmount: val + '',
            businessContractTotalAmount: val + '',
          };
        },
        immediate: true,
      },
      // 采购数量
      purchaseQuantity: {
        handler(val) {
          this.baseFormData = {
            ...this.baseFormData,
            purchaseQuantity: val + '',
          };
        },
        immediate: true,
      },
      isDisabledPricingRule: {
        handler(val) {
          console.log(val, '监听是否定价');
          this.baseFormData = {
            ...this.baseFormData,
            isFixedPrice: val ? '1' : '0',
          };
        },
        immediate: true,
      },
      fetchFormData: {
        handler(val) {
          if (val && Object.keys(val).length) {
            this.baseFormData = val;
            const {
              latestShipmentDate,
              latestPickUpFate,
              latestPayableSettlementFate,
              replyInvoiceFate,
              baseFormData,
            } = val;
            this.form = {
              latestShipmentDate,
              latestPickUpFate,
              latestPayableSettlementFate,
              replyInvoiceFate,
            };
            this.baseForm = baseFormData;
            console.log(val, '表单数据', val.isDefault, val.liquidatedDamagesType);
            // 判断禁用
            if (val.isDefault) {
              if (val.liquidatedDamagesType == 'RATE') {
                this.disabledFieldList = ['liquidatedFixedValue'];
              } else {
                this.disabledFieldList = ['liquidatedInterestRate'];
              }
            } else {
              this.disabledFieldList = [
                'liquidatedDamagesType',
                'liquidatedFixedValue',
                'liquidatedInterestRate',
              ];
            }

            this.getProjectByProjectNo(this.baseFormData.projectInitiationNo);
            this._getCompanyApi();
            this.$refs.formItem.clearValidate();
          }
        },
        immediate: true,
        deep: true,
      },
    },
  };
</script>

<style scoped>
  ::v-deep .el-form-item__label {
    font-size: 13px;
  }
</style>
